module.exports = __webpack_public_path__ + "static/media/logo_apple.3bebc6fd.png";